import TileControl from "./TileControl";

export default TileControl;
